module.exports = __webpack_public_path__ + "static/media/2.ff10fa45.jpg";